import React from 'react';
import {connect} from "react-redux";
import DateDisplay from "../../Boilerplate/DateDisplay";
import {Button, Card, Col, Divider, Row} from "antd";
import {NavLink} from "react-router-dom";
import Fuse from "fuse.js";
import PropTypes from 'prop-types';
import SearchBox from "../../Boilerplate/SearchBox";
import ExpandedList from "../../Boilerplate/ExpandedList";
import {deletePunch, getPunchLists} from "../../../actions/punchList";
import UserSmall from "../../Boilerplate/UserSmall";
import {canCreateSub, canDelete} from "../../Boilerplate/permissions";
import {separatorJoin} from "../../Boilerplate/utilities";
import PunchListSummary from "./PunchListSummary";
import {CodeTag} from "../../Boilerplate/CodeTag";
import {compArr, subdocumentStatusReportSelector, subViewSelector} from "../selectors";
import {setViewPath} from "../../../actions/view";
import {withLoading} from "../../Boilerplate/deferLoaderHoc";
import {compose} from "redux";
import {DeleteButton} from "../DeleteButton";

class PunchListList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterKeys: null,
      filterActive: false,
      statusFilter: null,
    };
  }

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) onMount();
  }

  setFilter = (phrase) => {
    if (phrase !== '') {
      let { punchList } = this.props;
      punchList = punchList || [];
      const options = {
        keys: [
          'resource.description',
        ],
        threshold: 0.3,
        id: 'resource.id'
      };
      let fuse = new Fuse(punchList, options);
      this.setState({
        filterKeys: fuse.search(phrase),
        filterActive: true,
      });
    } else {
      this.setState({
        filterKeys: [],
        filterActive: false,
      });
    }
  };

  setFilterCode = (code) => {
    this.setState({
      statusFilter: code
    });
  };

  clearFilterCode = () => {
    this.setFilterCode(null);
  };

  handleGraphClick = (e) => {
    let category = e.name;
    let { statusSummary } = this.props;
    let chosen = statusSummary.find(x => x.key.name === category);
    if (chosen) {
      this.setFilterCode(chosen.key.code);
    }
  };

  static getDerivedStateFromError(error) {
    return {
      error: error
    };
  }

  render() {
    let { punchList, project } = this.props;
    punchList = punchList || [];

    const { error } = this.state;
    if (error) return <pre>{error.toString()}</pre>;

    const { filterKeys, filterActive, statusFilter } = this.state;
    if (statusFilter) {
      punchList = punchList.filter(item => item.resource.status === statusFilter);
    }
    if (filterActive) {
      punchList = punchList.filter(item => filterKeys.includes(item.resource.id));
    }

    let index = punchList.map(i=>i.resource);
    index.sort((a, b) => a.datecreated-b.datecreated);
    index = index.map(i=>i.id);

    return (
      <React.Fragment>
        <Row gutter={16}>
          <Col span={18}>
            <Card>
              <div className="bid-listing-header">
                <h1>Punch List</h1>
                <SearchBox
                  className='control-box control-search'
                  placeholder='search punch list'
                  onChange={value => this.setFilter(value)}
                />
              </div>
              <Divider/>
              <ExpandedList
                items={punchList}
                index={index}
                derivedKey={item => item.resource.id}
                extra={(<Button type="primary" icon="plus" onClick={this.props.onNew} disabled={!canCreateSub('punchlistitem')(project)}>New Punch List Item</Button>)}
                subExtra={<div>
                  {statusFilter && <Button className={'clear-filter'} size="small" onClick={this.clearFilterCode}>Clear Status Filter</Button>}
                </div>}
                renderHeading={() => (
                  <Row className='bid-listing-heading text-column'>
                    <Col span={10}>Punch List Item</Col>
                    <Col span={3}>Created Date</Col>
                    <Col span={4}>Due Date</Col>
                    <Col span={2}>Priority</Col>
                    <Col span={5}>Status</Col>
                  </Row>
                )}
                renderTop={punch => {
                  let options = [];
                  if (canDelete(punch)) options.push(<DeleteButton fauxKey={'delete-' + punch.resource.id} icon='delete'
                    title='Delete Punch List Item' document={punch} onDelete={this.props.onDelete} type='punch list item'/>);
                  return (
                    <Row justify='space-between'>
                      <Col span={10}>
                        <NavLink to={punch.resource.id}>{'#' + punch.resource.number + ' - ' + punch.resource.name}</NavLink>
                      </Col>
                      <Col span={3}>
                        <DateDisplay date={punch.resource.datecreated}/>
                      </Col>
                      <Col span={4}>
                        <DateDisplay date={punch.resource.duedate}/>
                      </Col>
                      <Col span={2}>
                        <CodeTag table='punchlistitempriority' code={punch.resource.priority}/>
                      </Col>
                      <Col span={2}>
                        <CodeTag code={punch.resource.status} table='punchlistitemstatus'
                                 onClick={() => this.setFilterCode(punch.resource.status)}/>
                      </Col>
                      <Col span={3}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                          {separatorJoin(options, <span> | </span>)}
                        </div>
                      </Col>
                    </Row>
                  );
                }}
                renderContent={punch => (
                  <React.Fragment>
                    <p>{punch.resource.description}</p>
                    <p>Created by <UserSmall id={punch.resource.createdbyuserid}/>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;Assigned to <UserSmall id={punch.resource.owneruserid}/></p>
                  </React.Fragment>
                )}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <PunchListSummary
                title='Punch Items by Status'
                onClick={this.handleGraphClick}
              />
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

PunchListList.propTypes = {
  punchList: PropTypes.arrayOf(PropTypes.object),
  statusSummary: PropTypes.array.isRequired,
};

export default compose(
  connect(
    (state, props) => {
      const project = state.view.data[props.match.params.id];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const listpath = ['projects', props.match.params.id, 'punches'];
      if (!compArr(path, listpath) || loading) return { loading: true };
      const punchList = subViewSelector(state, props);
      const statusSummary = subdocumentStatusReportSelector(state, { path: 'punches', code: 'punchlistitemstatus' });
      return { punchList, statusSummary, project };
    },
    (dispatch, props) => ({
      loader: () => {
        dispatch(setViewPath(['projects', props.match.params.id, 'punches']));
        dispatch(getPunchLists(props.match.params.id));
      },
      onNew: () => props.history.push(`/projects/${props.match.params.id}/punch-list/new`),
      onDelete: (punchListId) => dispatch(deletePunch(props.match.params.id, punchListId)),
    })),
  withLoading
)(PunchListList);



// WEBPACK FOOTER //
// ./src/components/Projects/PunchList/PunchListList.js